export default __webpack_public_path__ + "assets/images/655a3471b6d2d3b924e0096f492d5b8b.svg";